import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { THEMES } from "@/lib/constants";

const ThemeContext = createContext(null);
const STORAGE_KEY = "sb_theme";

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "sunny";
    return localStorage.getItem(STORAGE_KEY) || "sunny";
  });

  useEffect(() => {
    const root = document.documentElement;
    THEMES.forEach((t) => root.classList.remove(t.className));
    const active = THEMES.find((t) => t.id === theme) || THEMES[0];
    root.classList.add(active.className);
    if (active.id === "darknight") root.classList.add("dark");
    else root.classList.remove("dark");
  }, [theme]);

  const setTheme = useCallback((id) => {
    setThemeState(id);
    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch (_) {}
  }, []);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
